module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("UserEmail", "Email") ))==null?'':__t)+
'</legend><fieldset><div><label for="update-email-1">'+
((__t=( i18n.tc("UserEmail", "Email:") ))==null?'':__t)+
'</label> <input type="text" id="update-email-1" value="'+
((__t=( email ))==null?'':__t)+
'" data-input="update-email-1"></div><div class="hidden"><label for="update-email-2">'+
((__t=( i18n.tc("UserEmail", "Email once again:") ))==null?'':__t)+
'</label> <input type="text" id="update-email-2" data-input="update-email-2" data-validate-equal="update-email-1" class="disabled"></div></fieldset><p class="validation-errors input error"></p><span data-element="already-warning" class="input warning"></span><fieldset class="button-wrap"><button data-click="email-cancel">'+
((__t=( i18n.tc("UserEmail","Cancel") ))==null?'':__t)+
'</button> <button data-click="email-submit" class="primary">'+
((__t=( i18n.tc("UserEmailForm","Submit") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
